var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from 'fbm-ui';
import { Paper, Stack } from 'fbm-ui/lib/mui';
var Workplaces = function (_a) {
    var suggestionAnswer = _a.suggestionAnswer, referenceAnswer = _a.referenceAnswer;
    if (suggestionAnswer || referenceAnswer) {
        return (_jsxs(Stack, __assign({ sx: {
                backgroundColor: 'rgb(245, 245, 245)',
            }, p: 1, spacing: 1 }, { children: [suggestionAnswer && (_jsxs(_Fragment, { children: [_jsx(Typography, __assign({ variant: "body1", fontWeight: 700, sx: { color: '#4caf50' } }, { children: "\u5206\u6790\u5EFA\u8BAE" })), _jsx(Paper, __assign({ sx: { padding: '8px  26px 8px  8px ' }, variant: "outlined" }, { children: _jsx(Typography, __assign({ variant: "body2" }, { children: suggestionAnswer })) }))] })), referenceAnswer && (_jsxs(_Fragment, { children: [_jsx(Typography, __assign({ variant: "body1", fontWeight: 700, sx: { color: '#4caf50' } }, { children: "\u53C2\u8003\u6A21\u677F" })), _jsx(Paper, __assign({ sx: { padding: '8px 26px  8px  8px ' }, variant: "outlined" }, { children: _jsx(Typography, __assign({ variant: "body2", color: "textSecondary" }, { children: referenceAnswer })) }))] }))] })));
    }
    else {
        return null;
    }
};
export default Workplaces;
